import nextDynamic from 'next/dynamic';

const Content = nextDynamic(() => import('./home-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
